// Mirrors apps/hire/app/services/sms_sender/length.rb. Bird rejects an SMS over 12 segments;
// one character outside GSM 03.38 (an emoji, a curly quote) makes the whole body UCS-2.
// https://bird.com/docs/guides/sms/character-limits
export const MAX_SEGMENTS = 12;
export const GSM_7_SEGMENT_UNITS = 153;
export const UCS_2_SEGMENT_UNITS = 67;

const GSM_7_BASIC =
  "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà";
// Each costs two septets.
const GSM_7_EXTENSION = "^{}\\[~]|€\f";

const GSM_7_CHARS = new Set([...GSM_7_BASIC, ...GSM_7_EXTENSION]);
const GSM_7_EXTENSION_CHARS = new Set([...GSM_7_EXTENSION]);

export function measureSmsLength(text) {
  const chars = [...(text || '')];

  if (chars.every(char => GSM_7_CHARS.has(char))) {
    const units = chars.reduce(
      (sum, char) => sum + (GSM_7_EXTENSION_CHARS.has(char) ? 2 : 1),
      0,
    );
    const limit = MAX_SEGMENTS * GSM_7_SEGMENT_UNITS;
    return { encoding: 'gsm_7', units, limit, exceedsLimit: units > limit };
  }

  // Length is in UTF-16 code units, so an astral emoji counts twice.
  const units = (text || '').length;
  const limit = MAX_SEGMENTS * UCS_2_SEGMENT_UNITS;
  return { encoding: 'ucs_2', units, limit, exceedsLimit: units > limit };
}
